import { createContext } from 'react';

const LottoAssistantStateContext = createContext({
  messages: [],
  conversationId: null,
  isSendingMessage: false,
  flyingTicketSource: null,
  inputCommand: null,
  setInputCommand: () => {},
});

export default LottoAssistantStateContext;
